import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../utils/api';

const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const [projects, setProjects]       = useState([]);
  const [currentProject, setCurrentProjectState] = useState(null);
  const [loading, setLoading]         = useState(true);

  const fetchProjects = useCallback(async () => {
    try {
      const res = await api.get('/api/projects');
      setProjects(res.data);
      return res.data;
    } catch {
      return [];
    }
  }, []);

  // Restore last-used project from localStorage, fall back to first project
  useEffect(() => {
    fetchProjects().then(list => {
      if (!list.length) { setLoading(false); return; }
      const saved = localStorage.getItem('currentProjectId');
      const found = saved ? list.find(p => p.id === parseInt(saved, 10)) : null;
      setCurrentProjectState(found || list[0]);
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setCurrentProject = useCallback((project) => {
    setCurrentProjectState(project);
    localStorage.setItem('currentProjectId', project.id);
  }, []);

  return (
    <ProjectContext.Provider value={{ projects, currentProject, setCurrentProject, fetchProjects, loading }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useProject() {
  return useContext(ProjectContext);
}
